import rp441 from "./rp441";
import rp442 from "./rp442";
import RP474 from "./RP474";
import rp444 from "./rp444";
import rp445 from "./rp445";
import rp446 from "./rp446";
import rp447 from "./rp447";
import rp448 from "./rp448";
import rp451 from "./rp451";
import rp452 from "./rp452";
import rp453 from "./rp453";
import rp454 from "./rp454";
import rp455 from "./rp455";
import rp456 from "./rp456";
import rp457 from "./rp457";
import rp458 from "./rp458";
import rp459 from "./rp459";
import rp460 from "./rp460";
import rp912 from "./rp912";

import loan_register from "./loan_register";
import loan_disbursement_register from "./loan_disbursement_register";
export default {
  loan_disbursement_register,
  loan_register,
rp460,
rp459,
rp458,
rp457,
rp456,
rp455,
rp454,
rp453,
rp452,
rp451,
rp448,
rp447,
rp446,
rp445,
rp444,
RP474,
rp442,
rp441,
rp912
};
